import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { postAlertasInserirUsuarioEncaminhado } from "./services";
import { TRequestInserirUsuarioEncaminhado } from "./types";
import { toast } from "sonner";

const initialState: any = {
  status: "",
  idUsuario: null,
  idLoja: null,
  idRegional: null,
  nomeUsuario: null,
  idCliente: null,
};

export const actionPostAlertasInserirUsuarioEncaminhado = createAsyncThunk<
  string,
  TRequestInserirUsuarioEncaminhado
>(
  "ACTION_POST_ALERTA_INSERIR_USUARIO_ENCAMINHADO",
  async ({ idUsuario, idLoja, idRegional, nomeUsuario, idCliente }) => {
    console.log("Dados recebidos no Thunk:", {
      idUsuario,
      idLoja,
      idRegional,
      nomeUsuario,
      idCliente,
    });

    return postAlertasInserirUsuarioEncaminhado({
      idUsuario,
      idLoja,
      idRegional,
      nomeUsuario,
      idCliente,
    });
  },
);

const slicePostAlertasInserirUsuarioEncaminhado = createSlice({
  name: "POST_ALERTA_INSERIR_USUARIO_ENCAMINHADO",
  initialState,
  reducers: {
    actionResetPostAlertasInserirUsuarioEncaminhado: (state) => {
      state.status = "";
      state.data = "";
    },
  },
  extraReducers: {
    [`${actionPostAlertasInserirUsuarioEncaminhado.pending}`]: (state) => {
      state.status = "loading";
    },
    [`${actionPostAlertasInserirUsuarioEncaminhado.fulfilled}`]: (
      state,
      { payload },
    ) => {
      state.status = "success";
      state.data = payload;
    },
    [`${actionPostAlertasInserirUsuarioEncaminhado.rejected}`]: (state) => {
      state.status = "error";
    },
  },
});

export default slicePostAlertasInserirUsuarioEncaminhado.reducer;
export const { actionResetPostAlertasInserirUsuarioEncaminhado } =
  slicePostAlertasInserirUsuarioEncaminhado.actions;
